import React from 'react';
import classNames from 'classnames';
import Button from '../Button';
import './style.scss';

// Interface voor de props voor type-veiligheid
interface CampaignDetailsCtaProps {
  secondaryLink?: {
    uri: string;
    label: string;
  };
  formTriggerLabel: string;
  triggerFormPopup: () => void;
  onlyShowSecondaryButtonOn?: 'mobile' | 'desktop';
}

function CampaignDetailsCta({
  secondaryLink,
  formTriggerLabel,
  triggerFormPopup,
}: CampaignDetailsCtaProps) {
  const containerClasses = classNames(
    'campaign-details-cta',
  );

  return (
    <div className={containerClasses}>
      <Button onClick={triggerFormPopup}>
        {formTriggerLabel}
      </Button>

      {secondaryLink && (
        <Button
          href={secondaryLink.uri}
          title={secondaryLink.label}
          type="secondary"
        >
          {secondaryLink.label}
        </Button>
      )}
    </div>
  );
}

export default CampaignDetailsCta;
